import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const i18nInstance = registerI18nResources({
  namespace: '@mc/error-page',
  resources: {
    'en-US': enUS,
  },
})
